// ControlRadioButtonFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import RadioButtonControlView  from 'common-inputs/RadioButtonControlView.js';


//=============================================================================
//
// Creates a radio button, given a factoryService parameter key and
// a layout position. The factory key defines the
// control appearance through its template..
//
// -Maty Rocha, February 8, 2015
//
//=============================================================================
class ControlRadioButtonFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos , isGroupChild = false) {

        sequenceService.addRadioButton();
        const attributes = this.createChildAttributes( factoryKey, pos, isGroupChild ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.name = 'Radio Button';
        attributes.value = sequenceService.getRadioNumber();
        attributes.text = 'Option '+ sequenceService.getRadioNumber();
        attributes.checked = '';
        attributes.selected = false;
        attributes.styleColorText ='~selectionTextColor';
        attributes.styleColorTextOver ='~selectionTextOverColor';
        attributes.fontFamily = '~selectionFont';
        attributes.fontSize = '~selectionFont';
        attributes.textWeight = '~selectionFont';
        attributes.textStyle  = '~selectionFont';
        attributes.borderColor = '~selectionBorderColor';
        attributes.backgroundColor = '~selectionBgColor';
        attributes.transparentBackground = '~checkBgTransparent'; // PF-8700 added new property to allow transparent background, true by default
        attributes.advancedBgGradientColor = '~selectionBgGradientColor';
		attributes.inlineEditable = true;
		attributes.minWidth = 15;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"}
        ];

        const view = new RadioButtonControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlRadioButtonFactory = new ControlRadioButtonFactory();

export default controlRadioButtonFactory;
